import { render } from "./mainLayout.vue?vue&type=template&id=21ae83ea&scoped=true"
import script from "./mainLayout.vue?vue&type=script&lang=js"
export * from "./mainLayout.vue?vue&type=script&lang=js"

import "./mainLayout.vue?vue&type=style&index=0&id=21ae83ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ae83ea"]])

export default __exports__